import React from 'react'
// store
import { store } from 'store/store'
import { showModal } from 'store/reducers/modals'
// types
import { Modals } from 'constants/modals'

const MODAL_URL_PARAMS: Partial<Record<Modals, string>> = {
  [Modals.KPI_MINIMIZED_MODAL]: 'kpiId',
  [Modals.ACTION_MINIMIZED_MODAL]: 'actionId',
  [Modals.OBJECTIVE_MINIMIZED_MODAL]: 'objectiveId'
}

const MODAL_URL_ENTRIES = Object.entries(MODAL_URL_PARAMS) as [Modals, string][]

const setUrlParam = (paramName: string, value: string) => {
  const searchParams = new URLSearchParams(window.location.search)

  if (searchParams.get(paramName) === value) {
    return
  }

  searchParams.set(paramName, value)

  window.history.replaceState(null, '', window.location.pathname + '?' + searchParams.toString())
}

const removeUrlParam = (paramName: string) => {
  const searchParams = new URLSearchParams(window.location.search)

  if (!searchParams.has(paramName)) {
    return
  }

  searchParams.delete(paramName)

  const search = searchParams.toString()

  window.history.replaceState(null, '', window.location.pathname + (search ? `?${search}` : ''))
}

const ModalUrlSync: React.FC = () => {
  const wasOpen = React.useRef<Partial<Record<Modals, boolean>>>({})

  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    MODAL_URL_ENTRIES.forEach(([modalType, paramName]) => {
      const id = searchParams.get(paramName)

      if (id) {
        store.dispatch(showModal({ modalType, modalData: { id } }))
      }
    })
  }, [])

  React.useEffect(() => {
    const unsubscribe = store.subscribe(() => {
      MODAL_URL_ENTRIES.forEach(([modalType, paramName]) => {
        const modalData = store.getState().modals?.[modalType]

        if (modalData?.isOpen && modalData?.id) {
          wasOpen.current[modalType] = true
          setUrlParam(paramName, modalData.id)
        } else if (!modalData?.isOpen && wasOpen.current[modalType]) {
          wasOpen.current[modalType] = false
          removeUrlParam(paramName)
        }
      })
    })
    return unsubscribe
  }, [])

  return null
}

export default ModalUrlSync
